import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import Typography from '@mui/material/Typography';

const TextLink = ({ to, children, sx, className, variant, 'data-testid': dataTestId }) => {
  if (!to) {
    return (
      <Typography
        variant={variant}
        component="span"
        className={className}
        data-testid={dataTestId}
        sx={{
          ...sx,
          textDecoration: 'none',
          cursor: 'default',
        }}
      >
        {children}
      </Typography>
    );
  }

  return (
    <Typography
      variant={variant}
      component={RouterLink}
      to={to}
      className={className}
      data-testid={dataTestId}
      sx={sx}
    >
      {children}
    </Typography>
  );
};

TextLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.shape({}),
  className: PropTypes.string,
  variant: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default TextLink;
